import React from 'react'
import {Skeleton} from 'antd'
import './skeleton-style.scss'

export default function InputFieldSkeleton({labelWidth, maxWidth, block, inputHeight}) {
  return (
      <>
      <div className={'dfields-skeleton'}
           style={{  maxWidth: maxWidth, overflow:"hidden"}}
      >
        <div className={'dfields-label'}
             style={{maxWidth:labelWidth}}
        >
          <Skeleton.Input
            className={'label'}
            active={true}
            style={{maxWidth:labelWidth}}
            block={block ? block : true}
          />
        </div>
          <Skeleton.Input className={'dfields-input'} style={{height:inputHeight ? inputHeight : 60}} active={true}   block={block ? block : true} />
      </div>
    </>
  )
}
